module.exports = __webpack_public_path__ + "img/file-solid.d4879864.svg";